import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

/**
 * Cinco pantallas y un login. Las vistas se cargan en diferido para que entrar
 * al panel no descargue el módulo de gráficas ni el de sucursales.
 */
export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/modules/auth/views/LoginView.vue'),
      meta: { public: true },
    },
    {
      path: '/',
      component: () => import('@/components/layout/AppShell.vue'),
      children: [
        {
          path: '',
          name: 'stats',
          component: () => import('@/modules/dashboard/views/DashboardView.vue'),
        },
        {
          path: 'chats',
          name: 'chats',
          component: () => import('@/modules/chats/views/ChatsView.vue'),
        },
        {
          path: 'ads',
          name: 'campaigns',
          component: () => import('@/modules/ads/views/CampaignsView.vue'),
        },
        {
          path: 'automated-messages',
          name: 'automated-messages',
          component: () => import('@/modules/ads/views/AutomatedMessagesView.vue'),
        },
        {
          path: 'branches',
          name: 'branches',
          component: () => import('@/modules/branches/views/BranchesView.vue'),
        },
      ],
    },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()

  // La primera navegación pregunta al backend si la cookie sigue viva. Sin
  // esperar aquí, recargar en una pantalla interna rebotaría al login aunque
  // la sesión estuviera abierta.
  if (!auth.checked) await auth.bootstrap()

  if (to.meta.public) {
    return auth.isAuthenticated ? { name: 'stats' } : true
  }

  if (!auth.isAuthenticated) {
    return { name: 'login', query: to.fullPath === '/' ? {} : { redirect: to.fullPath } }
  }

  return true
})
